import { AppPlugin } from '~/plugins/_types';
import jobManagerInstance from '~/plugins/jobManager';
import { getJobs } from './jobs';

export default {
    name: 'jobManager',
    install: async () => {
        const jobs = getJobs();

        jobManagerInstance.registerBatch(jobs);
    },
    priority: 3,
} satisfies AppPlugin;
